<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 z-[9999] flex items-center justify-center">
      <!-- 遮罩层 -->
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="handleClose"></div>

      <!-- 弹窗内容 -->
      <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden transform transition-all scale-100">
        <!-- 图标区域 -->
        <div class="flex justify-center mt-6">
          <div class="w-16 h-16 rounded-full flex items-center justify-center" :class="iconBgClass">
            <svg class="w-8 h-8" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <!-- 成功图标 -->
              <template v-if="type === 'success'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </template>
              <!-- 错误图标 -->
              <template v-else-if="type === 'error'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </template>
              <!-- 警告图标 -->
              <template v-else-if="type === 'warning'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </template>
              <!-- 信息图标 -->
              <template v-else>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </template>
            </svg>
          </div>
        </div>

        <!-- 标题 -->
        <div class="px-6 pt-4 pb-2">
          <h3 class="text-lg font-bold text-center text-gray-800">{{ title || defaultTitle }}</h3>
        </div>

        <!-- 内容 -->
        <div class="px-6 py-2">
          <p class="text-center text-gray-600 text-sm leading-relaxed">{{ message }}</p>
        </div>

        <!-- 按钮 -->
        <div class="px-6 py-5">
          <button
            @click="handleClose"
            :class="[
              'w-full py-2.5 px-4 rounded-lg text-white transition-colors font-medium',
              confirmButtonClass
            ]"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MessageDialog',
  data() {
    return {
      visible: false,
      type: 'info',
      title: '',
      message: '',
      confirmText: '确定',
      duration: 0,
      timer: null
    }
  },
  computed: {
    defaultTitle() {
      const titles = {
        success: '操作成功',
        error: '操作失败',
        warning: '温馨提示',
        info: '系统提示'
      }
      return titles[this.type] || '系统提示'
    },
    iconBgClass() {
      const map = {
        success: 'bg-green-100',
        error: 'bg-red-100',
        warning: 'bg-yellow-100',
        info: 'bg-blue-100'
      }
      return map[this.type] || map.info
    },
    iconClass() {
      const map = {
        success: 'text-green-500',
        error: 'text-red-500',
        warning: 'text-yellow-500',
        info: 'text-blue-500'
      }
      return map[this.type] || map.info
    },
    confirmButtonClass() {
      const map = {
        success: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
        error: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700',
        warning: 'bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600',
        info: 'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700'
      }
      return map[this.type] || map.info
    }
  },
  methods: {
    show(options) {
      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.type = options.type || 'info'
      this.title = options.title || ''
      this.message = options.message || ''
      this.confirmText = options.confirmText || '确定'
      this.duration = options.duration || 0
      this.visible = true

      // 如果设置了自动关闭时间
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    close() {
      this.visible = false
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    handleClose() {
      this.close()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 弹窗进入动画 */
.fade-enter-active .relative,
.fade-leave-active .relative {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.fade-enter .relative {
  transform: scale(0.9);
  opacity: 0;
}
.fade-leave-to .relative {
  transform: scale(0.9);
  opacity: 0;
}
</style>
